
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";
// Insert Payment
export const insertPayment = createAsyncThunk(
    "posts/insertPayment",
    async (item, thunkApi) => {
      const { rejectWithValue } = thunkApi;
      try {
        const res = await request.post("https://ssl.vipwellness-suite.de/api/payments/create", item, {
          headers: {
            "Content-Type": "application/json; charset=utf8",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
  
        if (res.data.approval_url) {
          window.location.href = res.data.approval_url; // Redirect user to the approval URL
        }
        return res.data; // Returning the response data to the thunk
      } catch (error) {
        console.log(error.response.data);
        return rejectWithValue(error.response?.data || error.message); // Handle error correctly
      }
    }
  );
  const initialState = { records: [], Loading: false, erorr: null, reco: [] };

  const paySlice = createSlice({
    name:'pay',
    initialState,
    extraReducers:(builder)=>{
        // Insert Payment
    builder.addCase(insertPayment.pending, (state) => {
        state.Loading = true;
        state.erorr = null;
      });
      builder.addCase(insertPayment.fulfilled, (state, action) => {
        state.Loading = false;
        state.records.push(action.payload);
      });
      builder.addCase(insertPayment.rejected, (state, action) => {
        state.Loading = false;
        state.erorr = action.payload;
      });
    }

  })
  export default paySlice.reducer